





































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import {BankAccountOperations} from '@/enums/BankAccountOperations';
import BankAccountsApi from '@/apis/BankAccountsApi';
import BankAccountAutomaticBackupResponseModel from '@/models/bankaccounts/BankAccountAutomaticBackupResponseModel';

@Component({
        name: 'BankAccountBackups',
    },
)
export default class BankAccountBackups extends ViewBase {
    @Prop({default: 0, required: true})
    public bankAccountId!: number;

    public authorized: boolean = false;
    public loadingManual = false;
    public showSaveLink = false;
    public saveLinkHref = '';
    public saveLinkDownload = '';
    public loadingAuto = false;
    public autoBackup: BankAccountAutomaticBackupResponseModel = new BankAccountAutomaticBackupResponseModel();
    public showAutoBackup = false;

    public async created() {
        if ( this.$store.state.selectedBankAccount.authorizedOperations & BankAccountOperations.VIEW_BACKUPS )
        {
            this.authorized = true;
        }
    }

    public async onManualBackupButtonClickAsync() {
        try {
            this.loadingManual = true;
            this.showSaveLink = false;
            this.saveLinkHref = '';
            this.saveLinkDownload = '';
            this.resetProcessingValues();

            const api = new BankAccountsApi();
            const values = await api.getManualBackupAsync(this.bankAccountId, this.$store.state.member.jwt);

            const len = values.length - 1;
            let csv = '';

            for (let i = 0; i <= len; i++) {
                csv += values[i] + '\n';
            }

            const now = new Date();
            const fileName = now.toISOString().substring(0, 10) + ' ' + this.$store.state.selectedBankAccount.bankAccountName + '.csv';
            const file = new Blob([csv], {type: 'text/csv'});

            this.saveLinkHref = URL.createObjectURL(file);
            this.saveLinkDownload = fileName;

            this.showSaveLink = true;
        }
        catch (err) {
            await this.handleProcessingErrorAsync(err);
        }
        finally {
            this.loadingManual = false;
        }
    }

    public async onAutoBackupButtonClickAsync() {
        try {
            this.loadingAuto = true;
            this.showAutoBackup = false;
            this.resetProcessingValues();

            const api = new BankAccountsApi();
            this.autoBackup = await api.getAutomaticBackupAsync(this.bankAccountId, this.$store.state.member.jwt);
            this.showAutoBackup = true;
        }
        catch (err) {
            await this.handleProcessingErrorAsync(err);
        }
        finally {
            this.loadingAuto = false;
        }
    }
}

